import { render, staticRenderFns } from "./upload-sort-all.vue?vue&type=template&id=0d21b5d9&"
import script from "./upload-sort-all.vue?vue&type=script&lang=js&"
export * from "./upload-sort-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports